export default {
  title: 'Your website is ready',
  body_one: 'Reservations are still off for {{count}} restaurant:',
  body_other: 'Reservations are still off for {{count}} restaurants:',
  reasons: {
    license_required: 'Needs a Partner Plan',
    notification_email_required: 'Needs an email for booking notifications. Add it when you switch reservations on.',
    switched_off: 'Switched off in the reservation settings',
    activation_failed: 'Could not be switched on. Please try again in the reservation settings.',
  },
  buttons: {
    open_settings: 'Open reservation settings',
    continue: 'Continue to the website builder',
  },
};
